export default "__VITE_ASSET__DUVnUfX$__"